import { Typography } from '@/app/common/Typography';
import { cn } from '@workspace/lib';

interface AskGregSectionHeaderProps {
  title: string;
  subtitle?: string;
  description: string;
}

export function AskGregSectionHeader({ title, subtitle, description }: AskGregSectionHeaderProps) {
  return (
    <div className="gap-sm self-stretch flex flex-col items-start">
      {subtitle && (
        <Typography variant="bodySm" className="uppercase tracking-wide">
          {subtitle}
        </Typography>
      )}
      <Typography variant="h4" className="w-full">
        {title}
      </Typography>
      <Typography variant="bodyMd" className={cn('text-black! self-stretch block')}>
        {description}
      </Typography>
    </div>
  );
}
